class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		this.headerSection = this.closest(".shopify-section-header");
		this.detailsContainer = this.querySelector("details");
		this.summaryToggle = this.querySelector("summary");
		this.closeTimer = null;
		this.openAnimationFrame = null;
		this.closedLabel = this.summaryToggle.dataset.closedLabel;
		this.openLabel = this.summaryToggle.dataset.openLabel;
		this.header.preventHide = false;

		this.detailsContainer.addEventListener(
			"keyup",
			(event) => event.code === "Escape" && this.close(),
		);
		this.summaryToggle.addEventListener(
			"click",
			this.onSummaryClick.bind(this),
		);
		this.summaryToggle.setAttribute("role", "button");
		this.summaryToggle.setAttribute("aria-expanded", "false");
	}

	isOpen() {
		return this.detailsContainer.hasAttribute("open");
	}

	onSummaryClick(event) {
		event.preventDefault();
		if (event.target.closest("details").hasAttribute("open")) {
			this.close();
		} else {
			this.open(event);
			if (!this.header) return;
			this.header.preventHide = this.detailsContainer.open;
		}
	}

	onBodyClick(event) {
		if (!this.contains(event.target)) this.close(false);
	}

	open(event) {
		window.clearTimeout(this.closeTimer);
		window.cancelAnimationFrame(this.openAnimationFrame);
		this.detailsContainer.classList.remove("is-closing");
		this.header.classList.add("is-search-drawer-open");
		this.headerSection?.classList.add("is-search-drawer-open");
		this.headerSection?.classList.remove("shopify-section-header-hidden");
		document.documentElement.classList.add("is-search-drawer-open");

		const headerBottom = Math.max(0, this.header?.getBoundingClientRect().bottom || 0);
		this.detailsContainer.style.setProperty("--search-drawer-top", `${headerBottom}px`);

		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest("details").setAttribute("open", true);
		this.summaryToggle.setAttribute("aria-expanded", "true");
		if (this.openLabel) this.summaryToggle.setAttribute("aria-label", this.openLabel);
		document.body.addEventListener("click", this.onBodyClickEvent);
		document.body.classList.add("overflow-hidden");

		this.detailsContainer.querySelector(".header__search-inner")?.getBoundingClientRect();
		this.openAnimationFrame = window.requestAnimationFrame(() => {
			this.detailsContainer.classList.add("is-opening");
		});

		trapFocus(
			this.detailsContainer.querySelector(".header__search-inner"),
			this.detailsContainer.querySelector('input:not([type="hidden"])'),
		);
	}

	close(focusToggle = true) {
		if (!this.detailsContainer.hasAttribute("open")) return;

		window.cancelAnimationFrame(this.openAnimationFrame);
		this.detailsContainer.classList.remove("is-opening");
		this.detailsContainer.classList.add("is-closing");
		document.body.removeEventListener("click", this.onBodyClickEvent);

		const searchDrawer = this.detailsContainer.querySelector(".header__search-inner");
		let isClosed = false;

		const finishClose = () => {
			if (isClosed) return;
			isClosed = true;
			window.clearTimeout(this.closeTimer);
			removeTrapFocus(focusToggle ? this.summaryToggle : null);
			this.detailsContainer.removeAttribute("open");
			this.detailsContainer.classList.remove("is-closing");
			this.detailsContainer.style.removeProperty("--search-drawer-top");
			this.summaryToggle.setAttribute("aria-expanded", "false");
			if (this.closedLabel) this.summaryToggle.setAttribute("aria-label", this.closedLabel);
			document.body.classList.remove("overflow-hidden");
			document.documentElement.classList.remove("is-search-drawer-open");
			this.header.classList.remove("is-search-drawer-open");
			this.headerSection?.classList.remove("is-search-drawer-open");
			this.header.preventHide = false;
		};

		const onTransitionEnd = (event) => {
			if (event.target !== searchDrawer || event.propertyName !== "transform") return;
			searchDrawer.removeEventListener("transitionend", onTransitionEnd);
			finishClose();
		};

		searchDrawer?.addEventListener("transitionend", onTransitionEnd);
		this.closeTimer = window.setTimeout(finishClose, 400);
	}
}

customElements.define("details-modal", DetailsModal);
